import React from 'react'
import clsx from 'clsx'
import { TableProps as AntTableProps } from 'antd/lib/table'

import { Table } from '@pepper/ui'

import styles from './SEOTable.module.css'

// using same typescript definition as antd
function SEOTable<RecordType extends object>({
  className,
  footer,
  ...rest
}: AntTableProps<RecordType>): React.ReactElement {
  return (
    <Table<RecordType>
      className={clsx(styles.seoTable, className, {
        [styles.bottomRounded]: footer === undefined,
      })}
      footer={footer}
      {...rest}
    />
  )
}

export default SEOTable
